










import { Component, Mixins } from 'vue-property-decorator';
import AddEditForm from './components/add-edit-form.vue';
import GoBackWithCloseTabMixin from '@root/common/mixins/go-back-with-close-tab';
import { GANG_STOP_PERSON } from '../router-names';

@Component({
  components: { AddEditForm }
})
export default class GangStopCreate extends Mixins(GoBackWithCloseTabMixin) {
  path = '/smart-parking/parking-lot-management/gang-stop-person';
  headTitle = '新增岗亭账号'; // 标题
  formData = [];
  // 面包屑数据
  get breadcrumbNav() {
    return [
      {
        label: '岗亭账号信息',
        location: {
          name: GANG_STOP_PERSON
        }
      },
      {
        label: this.headTitle
      }
    ];
  }

  isSubmitOk() {
    this.goBack('/smart-parking/parking-lot-management/gang-stop-person');
  }
}
